import styled from 'styled-components';

export default styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	height: 100%;
	background: #000;
	#login-wrapper {
		padding: 50px;
		text-align: center;
		#login-form {
			margin-top: 50px;
		}
		#logo {
			width: 100px;
		}
		.title {
			font-size: 20px;
			color: #fff;
			font-weight: bold;
		}
	}
	#login-button {
		position: fixed;
		bottom: 50px;
		left: 50%;
		background: #fff;
		color: #000;
		width: 60%;
		display: block;
		transform: translateX(-50%);
		font-weight: bold;
		margin: 0;
	}
	#show-cookies {
		position: absolute;
		bottom: 30px;
		right: 30px;
		width: 30px;
		height: 30px;
		border: 0;
		border-radius: 10rem;
		display: flex;
		align-items: baseline;
		justify-content: center;
		font-size: 30px;
		background: rgba(255, 255, 255, 0.05);
	}
`;
